import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { Product } from "../types";

export interface ProductState {
  selectedItem: Product | null;
  recount: number;
}

const initialState: ProductState = {
  selectedItem: null,
  recount: 0,
};

export const products = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProduct: (state, action: PayloadAction<Product>) => {
      state.selectedItem = action.payload;
    },
    clearProduct: (state) => {
      state.selectedItem = null;
    },
    incrementRecount: (state) => {
      state.recount += 1;
    },
  },
});

export const { setProduct, clearProduct, incrementRecount } = products.actions;

export const selectProduct = (state: RootState) => state.products.selectedItem;
export const recount = (state: RootState) => state.products.recount;

export default products.reducer;
